import React from 'react';
import { motion } from 'framer-motion';
import { Search } from 'lucide-react';

export default function Hero() {
  return (
    <section className="relative pt-24 pb-12 bg-gradient-to-br from-green-900 to-green-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1 className="text-4xl font-bold text-white mb-6">
            Research & Insights
          </h1>
          <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto">
            Explore our latest research, analysis, and insights on climate finance and sustainable development
          </p>
          
          <div className="max-w-xl mx-auto">
            <div className="relative">
              <input
                type="text"
                placeholder="Search insights..."
                className="w-full px-4 py-3 pl-12 rounded-full bg-white/10 border border-white/20 text-white placeholder-green-100 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-green-100" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}